AuthRoute          = require 'mixins/authenticated-route'
TeardownController = require 'mixins/teardown-controller'

App.DeliveryCouriersShowRoute = Em.Route.extend [
  AuthRoute,
  TeardownController
]...,
  model: (params) ->
    @store.fetchById('courier', params.courier_id)

  controllerName: 'deliveryCouriersEdit'
  templateName:   'delivery.couriers.edit'
